import type { ComplianceStop } from 'src/features/reporting/utils/color';
import type { ActionPriority } from './types';

export const ACTION_PRIORITY_OPTIONS: { value: ActionPriority; label: string }[] = [
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' }
];

const PRIORITY_SORT_ORDER: Record<ActionPriority, number> = {
  high: 0,
  medium: 1,
  low: 2
};

export function actionPriorityLabel(priority: ActionPriority): string {
  switch (priority) {
    case 'high':
      return 'High';
    case 'medium':
      return 'Medium';
    case 'low':
      return 'Low';
    default:
      return priority;
  }
}

export function actionPriorityRating(priority: ActionPriority): ComplianceStop {
  switch (priority) {
    case 'high':
      return 1;
    case 'medium':
      return 2;
    case 'low':
      return 4;
    default:
      return 'na';
  }
}

export function parseActionPriority(value: string | null | undefined): ActionPriority | null {
  if (!value) return null;
  const normalised = value.trim().toLowerCase();
  if (normalised === 'low' || normalised === 'medium' || normalised === 'high') {
    return normalised;
  }
  return null;
}

export function compareActionPriority(
  a: ActionPriority | null | undefined,
  b: ActionPriority | null | undefined
): number {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return PRIORITY_SORT_ORDER[a] - PRIORITY_SORT_ORDER[b];
}
